/*
 * Javascript for the home page
*/
import Swiper from "swiper";
import { Autoplay, EffectFade, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade";

var initAutocomplete;
(function($) {
	

	if($('body.home').length) {
		$('.login-tabs li').click(function() {
			var tab_id = $(this).attr('data-tab');

			$('.login-tabs li').removeClass('active');
			$('.tab-content').removeClass('current');

			$(this).addClass('active');
			$("#"+tab_id).addClass('current');
		});
		//$('.home-members-block, .project').matchHeight();

		document.addEventListener('DOMContentLoaded', function () {
			console.log('swiping');
			const swiper = new Swiper('.hero-slick-container', {
				modules: [Autoplay, EffectFade],
				slidesPerView: 1,
				loop: true,
				autoplay: {
					delay: 4000,
					disableOnInteraction: false
				},
				effect: 'fade',
				fadeEffect: {
					crossFade: true
				},
				allowTouchMove: true,
				speed: 1000,
				navigation: true
			});
		});

		//Google maps autocomplete
		//Basically taken from church-search.js
		//Placeholder autocomplete
		/*
		jQuery(function($) {
			// Asynchronously Load the map API
			var script = document.createElement('script');
			script.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyDbPsPZf7bNLXfulbubvVYua43pyoKdWno&libraries=places&callback=initAutocomplete";
			document.body.appendChild(script);
		});

		initAutocomplete = function(){
			var input = document.getElementById('search_place');
			var autocomplete = new google.maps.places.Autocomplete(input);
			// Set initial restrict to the greater list of countries.
			autocomplete.setComponentRestrictions({'country': ['gb']});

			autocomplete.addListener('place_changed', function() {
				var place = autocomplete.getPlace();
				if (place.geometry) {
					var lat = place.geometry.location.lat(),
							lng = place.geometry.location.lng();
					window.document.location = '/find-a-church?search_lat='+lat+'&search_lon='+lng;
				}
			});
		}
		*/

		$(document).ready(function(e) {
			//Geolocation stuff
			if(navigator.geolocation) {
				$(document).on('click','.get-location',function(e) {
					e.preventDefault();
					navigator.geolocation.getCurrentPosition(function(position){
						window.document.location = '/churches?search_lat='+position.coords.latitude+'&search_lon='+position.coords.longitude;
					}, function() {
						alert('There was a problem finding your location');
						console.error('Error getting your location');
						console.info('Might be on a non-https URL');
					});
					return false;
				});
			}
		});

	}
})(jQuery);
